<template>
  <!-- 一级 menu 菜单 -->
  <el-menu
    :default-active="activeMenu"
    :collapse="!$store.getters.sidebarOpened"
    :background-color="$store.getters.cssVar.menuBg"
    :text-color="$store.getters.cssVar.menuText"
    :active-text-color="$store.getters.cssVar.menuActiveText"
    :unique-opened="true"
    router
  >
    <sidebar-item
      v-for="item in filteredRoutes"
      :key="item.path"
      :route="item"
    ></sidebar-item>
  </el-menu>
</template>

<script setup>
import { computed } from 'vue'
import SidebarItem from './SidebarItem'
import { useRoute } from 'vue-router'
import { privateRoutes } from '../../../router'

/**
 * 过滤路由 - 只显示包含 meta.title 的路由
 */
const filterRoutes = (routes) => {
  return routes
    .filter((route) => {
      // 检查路由是否有 meta 并且有 title
      return route.meta && route.meta.title
    })
    .map((route) => {
      // 如果有子路由，递归过滤子路由
      if (route.children && route.children.length > 0) {
        const filteredChildren = filterRoutes(route.children)
        // 只保留有子路由的父路由，或者父路由本身是可显示的
        return {
          ...route,
          children: filteredChildren
        }
      }
      return route
    })
    .filter((route) => {
      // 如果有子路由，至少要有一个子路由可显示
      if (route.children) {
        return route.children.length > 0
      }
      return true
    })
}

// 计算过滤后的路由表结构
const filteredRoutes = computed(() => {
  return filterRoutes(privateRoutes)
})

// 计算高亮 menu 的方法
const route = useRoute()
const activeMenu = computed(() => {
  const { meta, path } = route
  if (meta && meta.activeMenu) {
    return meta.activeMenu
  }
  return path
})
</script>

<style lang="scss" scoped></style>
